









































import { Component, Vue, Prop } from 'vue-property-decorator';

import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListDeposit extends Vue {
    @Prop({default: {}})
    private listDeposit: any;

    private async viewDetail(deposit: any) {
        const routeData = this.$router.resolve({ name: 'deposit-detail', params: { id: deposit.id.toString() } });
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }

        return formatNumber(value, format);
    }
}
